import React from 'react';
import {
  Row,
  Col,
  Input,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import OnTraccrButton from '../common/buttons/OnTraccrButton';

import { safeExtractFromObject } from '../helpers/helpers';
import CardGridFilterButton from '../common/cardGrid/CardGridFilterButton';

export default function SubtasksHeader({
  onAddClicked,
  onSearch,
  filter,
  filterActive,
  searchTerm = '',
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  const onSearchChanged = (e) => {
    const {
      target: { value } = {},
    } = e;
    onSearch(value);
  };

  return (
    <Row justify="start" style={{ marginBottom: 14, paddingTop: hasRedesign ? 4 : 0 }} gutter={20}>
      <Col>
        <Input.Search
          type="search"
          style={{ width: 250 }}
          className="searchbar"
          placeholder="Search"
          allowClear
          value={searchTerm}
          onChange={onSearchChanged}
        />
      </Col>
      <Col>
        {filter && (
          <CardGridFilterButton
            filter={filter}
            filterActive={filterActive}
          />
        )}
      </Col>
      <Col flex="auto" />
      <Col>
        {onAddClicked && (
          <OnTraccrButton
            iconLeft
            icon={<PlusOutlined />}
            title="Add Task"
            onClick={onAddClicked}
          />
        )}
      </Col>
    </Row>
  );
}

SubtasksHeader.propTypes = {
  onAddClicked: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  filter: PropTypes.func.isRequired,
  filterActive: PropTypes.bool.isRequired,
  searchTerm: PropTypes.string,
};

SubtasksHeader.defaultProps = {
  searchTerm: '',
};
